import React from 'react';

const human = {
  name: 'Ginger "The Human"',
  description:
    'The human behind the curtain — fantasy storyteller, AI artist, founder, and chief world-builder. Coffee in one hand, dark fantasy in the other, and the one the dogs pretend to listen to.',
  image:
    'https://customer-assets-v7afamib.emergentagent.net/job_cc339f9e-450d-46e0-915d-8c3f1a0f1e38/artifacts/3z8shktd_Whisky%26Me.png',
};

const dogs = [
  {
    name: 'Whisky & Mia',
    description:
      'The chocolate lab mascot and the boss of hiking adventures. Whisky is the business namesake; Mia keeps everyone in line.',
    image:
      'https://customer-assets-v7afamib.emergentagent.net/job_cc339f9e-450d-46e0-915d-8c3f1a0f1e38/artifacts/0agl8uu6_Whisky%3AMia%20.png',
  },
];

const CrewCard = ({ member, testid, imageClass = 'aspect-[4/5]' }) => (
  <div className="group corner-frame" data-testid={testid}>
    <div className="overflow-hidden bg-[#0A0A0B]">
      <img
        src={member.image}
        alt={`${member.name} - member of the Whisky Woven crew`}
        className={`w-full ${imageClass} object-cover transition-transform duration-700 group-hover:scale-[1.03]`}
        loading="lazy"
      />
    </div>
    <div className="pt-5">
      <h3 className="text-2xl font-medium text-[#F0EDE8] mb-2">{member.name}</h3>
      <p className="text-[#E8E4DF]">{member.description}</p>
    </div>
  </div>
);

const Dogs = () => {
  return (
    <section id="dogs" className="py-24 lg:py-36 bg-[#0A0A0B]" data-testid="dogs-section">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <p className="label-sm text-[#14B8A6] mb-4" data-font="label">The Crew</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-[#F0EDE8]" data-testid="dogs-heading">
              Meet the Crew
            </h2>
          </div>

          <div className="max-w-xl mx-auto mb-12">
            <CrewCard member={human} testid="crew-card-ginger" imageClass="aspect-[4/3]" />
          </div>

          <div className="grid grid-cols-1 gap-10 max-w-2xl mx-auto">
            {dogs.map((dog) => (
              <CrewCard
                key={dog.name}
                member={dog}
                testid={`dog-card-${dog.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                imageClass="aspect-[4/3]"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dogs;
